import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourSeguridadSesiones: TourDefinicion = {
  codigo: 'seguridad-sesiones',
  titulo: 'Sesiones',
  descripcion: 'Sesiones activas del usuario y revocación.',
  ruta: '/admin/seguridad/sesiones',
  permisoMenu: Permisos.SESIONES_MENU,
  pasos: [
    {
      id: 'seguridad-sesiones:header',
      selector: '[data-testid="seguridad-sesiones.header"]',
      titulo: 'Sesiones activas',
      descripcion:
        'Lista de tus sesiones abiertas en distintos navegadores o dispositivos. Útil para verificar accesos sospechosos.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'seguridad-sesiones:tabla',
      selector: '[data-testid="seguridad-sesiones.tabla"]',
      titulo: 'Revocar',
      descripcion:
        'Puedes revocar una sesión específica desde la acción de la fila. La próxima request de ese dispositivo fallará y deberá volver a loguearse.',
      side: 'top',
      align: 'center',
    },
  ],
};
